import {makeAutoObservable} from "mobx";
import {displayErrorDialogPrompt} from "../common/util/errror/log.util";
import cloneDeep from 'lodash/cloneDeep';
import {getDayPath, getDefaultContentUrl} from "./ContentStore";
import {VoiceType} from "../common/enums/VoiceType";
import {langTypes} from "../common/enums/ExcelEnum";
import {LangType} from "../common/enums/ContentEnum";

const logPrefix  = "[EvenStepOneStore]"
export default class EvenStepOneStore {

    constructor(props) {
        this.contentRepository = props.contentRepository;
        this.contentStore = props.contentStore;
        this.dialogStore = props.dialogStore;
        this.commonStore = props.commonStore;

        this.contentTapIndex = 0;
        this.audio = null;
        this.voiceType = VoiceType.MAN;
        this.contentList = [];
        this.selectedContent = [];
        this.dialogueRoles = [];
        this.sentenceDialogueRoles = [];
        this.timeoutId = 0;
        this.isProcessingPoint = false;
        this.isDeleteFlag = false;
        this.readyToSaveStep = false;
        this.stepValue = 0;
        this.dayValue = 0;

        makeAutoObservable(this);
    }

    initEvenStepOneContent = () => {
        this.isDeleteFlag = false;
        this.audio = null;
        this.contentList = [];
        this.selectedContent = [];
        this.dialogueRoles = [];
        this.sentenceDialogueRoles = [];
        this.contentTapIndex = 0;
    }

    setContentTapIndex = (index) => {
        this.contentTapIndex = index;
        this.setSelectedContent();
    };

    openErrorDialog = (info) => {
        if (this?.dialogStore) {
            this.dialogStore.openErrorDialog(info)
        }
    }

    setSpeakerName = (name, i) => {
        this.dialogueRoles[i].speakerName = name;
    }

    setVoiceType = (voice, i) => {
        this.dialogueRoles[i].voiceType = voice;
    }

    setSelectedContent = () => {
        this.selectedContent = this.getSelectedContent(this.getSelectedLangCode())[0];
    }

    setStepValue = (step) => {
        this.stepValue = step;
    }

    setDayValue = (day) => {
        this.dayValue = day;
    }

    setDialogueRoles = () => {
        this.dialogueRoles = Array.from(new Set(this.selectedContent?.contents?.map((content, i) => JSON.stringify({
            speakerName: content.speakerName,
            voiceType: content.voiceType
        })))).map(str => JSON.parse(str));
        this.sentenceDialogueRoles = cloneDeep(this.dialogueRoles);
    }

    setSentenceRoles = () => {
        this.contentList.forEach(cl => {
            cl.contents.forEach(c => {
                this.sentenceDialogueRoles.forEach((dr, i) => {
                    if (dr.speakerName === c.speakerName) {
                        c.speakerName = this.dialogueRoles[i].speakerName;
                        c.voiceType = this.dialogueRoles[i].voiceType;
                        if (this.dialogueRoles[i].voiceType !== dr.voiceType) {
                            c.audioExist = false;
                        }
                    }
                })
            });
        });
        this.contentStore.setReadyToSaveStep(this.isEvenStepOneCompleted());
        this.readyToSaveStep = this.isEvenStepOneCompleted();
        this.sentenceDialogueRoles = cloneDeep(this.dialogueRoles);
    }

    setReorderedContents = (contents, langeCode) => {
        this.contentList.filter(content => content.languageCode === langeCode)[0].contents = contents;
        this.contentStore.setReadyToSaveStep(this.isEvenStepOneCompleted());
        this.readyToSaveStep = this.isEvenStepOneCompleted();
    }

    setDialogueContentText = (value, index, contents) => {
        const reorderedContents = Array.from(contents);
        reorderedContents[index].text = value;
        reorderedContents[index].audioExist = false;
        this.setReorderedContents(reorderedContents, this.getSelectedLangCode());
    }

    setDialogueContentAudio = (audio, index, contents) => {
        const reorderedContents = Array.from(contents);
        reorderedContents[index].audio = audio.split(',')[1];
        reorderedContents[index].audioExist = true;
        this.setReorderedContents(reorderedContents, this.getSelectedLangCode());
    }

    setDialogueContentRole = (value, index) => {
        this.contentList.forEach(cl => {
            const reorderedContents = Array.from(cl.contents);
            const voiceType = this.sentenceDialogueRoles.find(r => r.speakerName === value)?.voiceType;
            reorderedContents[index].speakerName = value;
            reorderedContents[index].audioExist = reorderedContents[index].voiceType === voiceType;
            reorderedContents[index].voiceType = voiceType;
            this.setReorderedContents(reorderedContents, cl.languageCode);
        });
    }

    setDeleteFlag = (flag) => {
        this.isDeleteFlag = flag;
    }

    convertRequestContents = () => {
        return this.contentList.map((c) => ({
            contentId: c.contentId,
            languageCode: c.languageCode,
            contents: c.contents.map((content, i) => {
                return ({
                    id : content.id,
                    sequence: i+1,
                    speakerName: content.speakerName,
                    text: content.text,
                    voiceType: content.voiceType,
                });
            })
        })).sort((a, b) => langTypes.indexOf(a.languageCode) - langTypes.indexOf(b.languageCode));
    }

    getSelectedLangCode = () => {
        return langTypes[this.contentTapIndex];
    }

    getSelectedContent = (langeCode) => {
        return this.contentList.filter(content => content.languageCode === langeCode);
    }

    isEvenStepOneCompleted = () => {
        const mainLangContents = this.getSelectedContent(LangType.KO)[0];
        const {contents} = mainLangContents;
        if (mainLangContents.languageCode === 'KO') {
            const hasEmptyValues = contents.some(content => {
                return content.text === '' || content.speakerName === '' || content.voiceType === '';
            });
            return !hasEmptyValues;
        } else {
            return false;
        }
    }


    playAudio = (audio, id) => {
        if (this.audio && !this.audio.paused && this.audio.id === id) {
            this.stopAudio();
        } else {
            if (this.audio) {
                this.stopAudio();
            }
            const decodeAudio = atob(audio);
            const blob = new Blob([new Uint8Array(decodeAudio.length).map((_, i) => decodeAudio.charCodeAt(i))], {type: 'audio/mp3'});
            this.audio = new Audio();
            this.audio.id = id;
            this.audio.src = URL.createObjectURL(blob);
            this.audio.play();
        }
    }

    stopAudio = () => {
        if (this.audio) {
            this.audio.pause();
            this.audio = null;
        }
    }

    * getEvenStepOneContent(step, day) {
        this.commonStore.setLoadingState();
        try {
            console.log(logPrefix, 'Start getEvenStepOneContent.');
            const url = `${getDayPath(day)}/${getDefaultContentUrl(step, day)}/1`;
            const response = yield this.contentRepository.getContent(url);
            this.contentList = response.data;
            this.contentStore.setReadyToMoveExit(this.isEvenStepOneCompleted());
            this.contentStore.setReadyToSaveStep(false);
            this.readyToSaveStep = false;
            this.setSelectedContent();
            this.setDialogueRoles();
            console.log(logPrefix, 'Finished getEvenStepOneContent.');
        } catch (e) {
            console.log(logPrefix, 'Failed getEvenStepOneContent.');
            this.openErrorDialog({
                titleText: '컨텐츠 불러오기 오류',
                text: displayErrorDialogPrompt(e, '컨텐츠를 불러오는 도중 에러가 발생했습니다.')
            });
        } finally {
            this.commonStore.initLoadingState();
        }
    }

    * modifyEvenStepOneContent(step, day) {
        this.commonStore.setLoadingState('데이터를 저장하는 중입니다.');
        try {
            console.log(logPrefix, 'Start modifyEvenStepOneContent.');
            const url = `${getDayPath(day)}/${getDefaultContentUrl(step, day)}/1?isDelete=${this.isDeleteFlag}`;
            const requestContents = this.convertRequestContents();
            console.log(logPrefix, 'modifyEvenStepOneContent requestContents :', requestContents);
            yield this.contentRepository.putContent(url, requestContents);
            console.log(logPrefix, 'Finished modifyEvenStepOneContent.');
            this.getEvenStepOneContent(step, day);
        } catch (e) {
            this.commonStore.initLoadingState();
            console.log(logPrefix, 'Failed modifyEvenStepOneContent.');
            this.openErrorDialog({
                titleText: '대화 수정 오류',
                text: displayErrorDialogPrompt(e, '본문 수정 작업중 에러가 발생했습니다.')
            });
        } finally {
            this.setDeleteFlag(false);
        }
    }

}

